export const timeZoneOptions = [
    { value: "American Samoa", display: "(GMT-11:00) American Samoa" },
    { value: "International Date Line West", display: "(GMT-11:00) International Date Line West" },
    { value: "Midway Island", display: "(GMT-11:00) Midway Island" },
    { value: "Hawaii", display: "(GMT-10:00) Hawaii" },
    { value: "Alaska", display: "(GMT-08:00) Alaska" },
    { value: "Arizona", display: "(GMT-07:00) Arizona" },
    { value: "Pacific Time (US &amp; Canada)", display: "(GMT-07:00) Pacific Time (US &amp; Canada)" },
    { value: "Tijuana", display: "(GMT-07:00) Tijuana" },
    { value: "Central America", display: "(GMT-06:00) Central America" },
    { value: "Chihuahua", display: "(GMT-06:00) Chihuahua" },
    { value: "Mazatlan", display: "(GMT-06:00) Mazatlan" },
    { value: "Mountain Time (US &amp; Canada)", display: "(GMT-06:00) Mountain Time (US &amp; Canada)" },
    { value: "Saskatchewan", display: "(GMT-06:00) Saskatchewan" },
    { value: "Bogota", display: "(GMT-05:00) Bogota" },
    { value: "Central Time (US &amp; Canada)", display: "(GMT-05:00) Central Time (US &amp; Canada)" },
    { value: "Guadalajara", display: "(GMT-05:00) Guadalajara" },
    { value: "Lima", display: "(GMT-05:00) Lima" },
    { value: "Mexico City", display: "(GMT-05:00) Mexico City" },
    { value: "Monterrey", display: "(GMT-05:00) Monterrey" },
    { value: "Quito", display: "(GMT-05:00) Quito" },
    { value: "Caracas", display: "(GMT-04:00) Caracas" },
    { value: "Eastern Time (US &amp; Canada)", display: "(GMT-04:00) Eastern Time (US &amp; Canada)" },
    { value: "Georgetown", display: "(GMT-04:00) Georgetown" },
    { value: "Indiana (East)", display: "(GMT-04:00) Indiana (East)" },
    { value: "La Paz", display: "(GMT-04:00) La Paz" },
    { value: "Puerto Rico", display: "(GMT-04:00) Puerto Rico" },
    { value: "Santiago", display: "(GMT-04:00) Santiago" },
    { value: "Atlantic Time (Canada)", display: "(GMT-03:00) Atlantic Time (Canada)" },
    { value: "Brasilia", display: "(GMT-03:00) Brasilia" },
    { value: "Buenos Aires", display: "(GMT-03:00) Buenos Aires" },
    { value: "Montevideo", display: "(GMT-03:00) Montevideo" },
    { value: "Newfoundland", display: "(GMT-02:30) Newfoundland" },
    { value: "Greenland", display: "(GMT-02:00) Greenland" },
    { value: "Mid-Atlantic", display: "(GMT-02:00) Mid-Atlantic" },
    { value: "Cape Verde Is.", display: "(GMT-01:00) Cape Verde Is." },
    { value: "Azores", display: "(GMT+00:00) Azores" },
    { value: "Monrovia", display: "(GMT+00:00) Monrovia" },
    { value: "UTC", display: "(GMT+00:00) UTC" },
    { value: "Casablanca", display: "(GMT+01:00) Casablanca" },
    { value: "Dublin", display: "(GMT+01:00) Dublin" },
    { value: "Edinburgh", display: "(GMT+01:00) Edinburgh" },
    { value: "Lisbon", display: "(GMT+01:00) Lisbon" },
    { value: "London", display: "(GMT+01:00) London" },
    { value: "West Central Africa", display: "(GMT+01:00) West Central Africa" },
    { value: "Amsterdam", display: "(GMT+02:00) Amsterdam" },
    { value: "Belgrade", display: "(GMT+02:00) Belgrade" },
    { value: "Berlin", display: "(GMT+02:00) Berlin" },
    { value: "Bern", display: "(GMT+02:00) Bern" },
    { value: "Bratislava", display: "(GMT+02:00) Bratislava" },
    { value: "Brussels", display: "(GMT+02:00) Brussels" },
    { value: "Budapest", display: "(GMT+02:00) Budapest" },
    { value: "Cairo", display: "(GMT+02:00) Cairo" },
    { value: "Copenhagen", display: "(GMT+02:00) Copenhagen" },
    { value: "Harare", display: "(GMT+02:00) Harare" },
    { value: "Kaliningrad", display: "(GMT+02:00) Kaliningrad" },
    { value: "Ljubljana", display: "(GMT+02:00) Ljubljana" },
    { value: "Madrid", display: "(GMT+02:00) Madrid" },
    { value: "Oslo", display: "(GMT+02:00) Oslo" },
    { value: "Paris", display: "(GMT+02:00) Paris" },
    { value: "Prague", display: "(GMT+02:00) Prague" },
    { value: "Pretoria", display: "(GMT+02:00) Pretoria" },
    { value: "Rome", display: "(GMT+02:00) Rome" },
    { value: "Sarajevo", display: "(GMT+02:00) Sarajevo" },
    { value: "Skopje", display: "(GMT+02:00) Skopje" },
    { value: "Stockholm", display: "(GMT+02:00) Stockholm" },
    { value: "Vienna", display: "(GMT+02:00) Vienna" },
    { value: "Warsaw", display: "(GMT+02:00) Warsaw" },
    { value: "Zagreb", display: "(GMT+02:00) Zagreb" },
    { value: "Athens", display: "(GMT+03:00) Athens" },
    { value: "Baghdad", display: "(GMT+03:00) Baghdad" },
    { value: "Bucharest", display: "(GMT+03:00) Bucharest" },
    { value: "Helsinki", display: "(GMT+03:00) Helsinki" },
    { value: "Istanbul", display: "(GMT+03:00) Istanbul" },
    { value: "Jerusalem", display: "(GMT+03:00) Jerusalem" },
    { value: "Kuwait", display: "(GMT+03:00) Kuwait" },
    { value: "Kyev", display: "(GMT+03:00) Kyev" },
    { value: "Kyiv", display: "(GMT+03:00) Kyiv" },
    { value: "Minsk", display: "(GMT+03:00) Minsk" },
    { value: "Moscow", display: "(GMT+03:00) Moscow" },
    { value: "Nairobi", display: "(GMT+03:00) Nairobi" },
    { value: "Riga", display: "(GMT+03:00) Riga" },
    { value: "Riyadh", display: "(GMT+03:00) Riyadh" },
    { value: "Sofia", display: "(GMT+03:00) Sofia" },
    { value: "St. Petersburg", display: "(GMT+03:00) St. Petersburg" },
    { value: "Tallinn", display: "(GMT+03:00) Tallinn" },
    { value: "Vilnius", display: "(GMT+03:00) Vilnius" },
    { value: "Abu Dhabi", display: "(GMT+04:00) Abu Dhabi" },
    { value: "Baku", display: "(GMT+04:00) Baku" },
    { value: "Muscat", display: "(GMT+04:00) Muscat" },
    { value: "Samara", display: "(GMT+04:00) Samara" },
    { value: "Tbilisi", display: "(GMT+04:00) Tbilisi" },
    { value: "Volgograd", display: "(GMT+04:00) Volgograd" },
    { value: "Yerevan", display: "(GMT+04:00) Yerevan" },
    { value: "Kabul", display: "(GMT+04:30) Kabul" },
    { value: "Tehran", display: "(GMT+04:30) Tehran" },
    { value: "Ekaterinburg", display: "(GMT+05:00) Ekaterinburg" },
    { value: "Islamabad", display: "(GMT+05:00) Islamabad" },
    { value: "Karachi", display: "(GMT+05:00) Karachi" },
    { value: "Tashkent", display: "(GMT+05:00) Tashkent" },
    { value: "Chennai", display: "(GMT+05:30) Chennai" },
    { value: "Kolkata", display: "(GMT+05:30) Kolkata" },
    { value: "Mumbai", display: "(GMT+05:30) Mumbai" },
    { value: "New Delhi", display: "(GMT+05:30) New Delhi" },
    { value: "Sri Jayawardenepura", display: "(GMT+05:30) Sri Jayawardenepura" },
    { value: "Kathmandu", display: "(GMT+05:45) Kathmandu" },
    { value: "Almaty", display: "(GMT+06:00) Almaty" },
    { value: "Astana", display: "(GMT+06:00) Astana" },
    { value: "Dhaka", display: "(GMT+06:00) Dhaka" },
    { value: "Urumqi", display: "(GMT+06:00) Urumqi" },
    { value: "Rangoon", display: "(GMT+06:30) Rangoon" },
    { value: "Bangkok", display: "(GMT+07:00) Bangkok" },
    { value: "Hanoi", display: "(GMT+07:00) Hanoi" },
    { value: "Jakarta", display: "(GMT+07:00) Jakarta" },
    { value: "Krasnoyarsk", display: "(GMT+07:00) Krasnoyarsk" },
    { value: "Novosibirsk", display: "(GMT+07:00) Novosibirsk" },
    { value: "Beijing", display: "(GMT+08:00) Beijing" },
    { value: "Chongqing", display: "(GMT+08:00) Chongqing" },
    { value: "Hong Kong", display: "(GMT+08:00) Hong Kong" },
    { value: "Irkutsk", display: "(GMT+08:00) Irkutsk" },
    { value: "Kuala Lumpur", display: "(GMT+08:00) Kuala Lumpur" },
    { value: "Perth", display: "(GMT+08:00) Perth" },
    { value: "Singapore", display: "(GMT+08:00) Singapore" },
    { value: "Taipei", display: "(GMT+08:00) Taipei" },
    { value: "Ulaan Bataar", display: "(GMT+08:00) Ulaanbataar" },
    { value: "Ulaanbaatar", display: "(GMT+08:00) Ulaanbaatar" },
    { value: "Osaka", display: "(GMT+09:00) Osaka" },
    { value: "Sapporo", display: "(GMT+09:00) Sapporo" },
    { value: "Seoul", display: "(GMT+09:00) Seoul" },
    { value: "Tokyo", display: "(GMT+09:00) Tokyo" },
    { value: "Yakutsk", display: "(GMT+09:00) Yakutsk" },
    { value: "Adelaide", display: "(GMT+09:30) Adelaide" },
    { value: "Darwin", display: "(GMT+09:30) Darwin" },
    { value: "Brisbane", display: "(GMT+10:00) Brisbane" },
    { value: "Canberra", display: "(GMT+10:00) Canberra" },
    { value: "Guam", display: "(GMT+10:00) Guam" },
    { value: "Hobart", display: "(GMT+10:00) Hobart" },
    { value: "Melbourne", display: "(GMT+10:00) Melbourne" },
    { value: "Port Moresby", display: "(GMT+10:00) Port Moresby" },
    { value: "Sydney", display: "(GMT+10:00) Sydney" },
    { value: "Vladivostok", display: "(GMT+10:00) Vladivostok" },
    { value: "Magadan", display: "(GMT+11:00) Magadan" },
    { value: "New Caledonia", display: "(GMT+11:00) New Caledonia" },
    { value: "Solomon Is.", display: "(GMT+11:00) Solomon Is." },
    { value: "Srednekolymsk", display: "(GMT+11:00) Srednekolymsk" },
    { value: "Auckland", display: "(GMT+12:00) Auckland" },
    { value: "Fiji", display: "(GMT+12:00) Fiji" },
    { value: "Kamchatka", display: "(GMT+12:00) Kamchatka" },
    { value: "Marshall Is.", display: "(GMT+12:00) Marshall Is." },
    { value: "Wellington", display: "(GMT+12:00) Wellington" },
    { value: "Chatham Is.", display: "(GMT+12:45) Chatham Is." },
    { value: "Nuku'alofa", display: "(GMT+13:00) Nuku'alofa" },
    { value: "Samoa", display: "(GMT+13:00) Samoa" },
    { value: "Tokelau Is.", display: "(GMT+13:00) Tokelau Is." },
]